"use strict";
import { definitionsFromContext } from "src/decidim/refactor/support/stimulus";
const context = require.context("../src/decidim/govbr/controllers", true, /controller\.js$/);
window.Stimulus.load(definitionsFromContext(context));
